import styled from "styled-components";

export const Backplate = styled.div`
    width: 100%;
    padding: 48px 32px 48px 32px;
    background-color: #2770d8;
    display: flex;
    flex-flow: row;
    border-radius: 40px;
    gap: 40px;

    @media (max-width: 1024px) {
        flex-flow: column;
    }
`;

export const Text = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    color: #ffffff;
`;
